import React, { FC } from 'react'

import { IconUnlockedRewardsProps } from './IconUnlockedRewards.types'
import * as Styled from './styles/IconUnlockedRewards.style'

import { nonThemeableRules } from '../../ruleSet'

const IconUnlockedRewards: FC<IconUnlockedRewardsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconUnlockedRewardsProps['size'],
  isResponsive = false,
}: IconUnlockedRewardsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M7.688 24.945h32.624a.687.687 0 0 1 .688.688v13.312a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4V25.632a.688.688 0 0 1 .688-.687Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M27.14 24.945h-6v18h6v-18Z' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M42.635 13.875a2.001 2.001 0 0 1-1.427 2.442L8.31 24.907a2 2 0 0 1-2.44-1.43l-.5-1.934a2 2 0 0 1 1.428-2.44L41.625 10l1.01 3.875Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='m10.33 8.891 3-.783a5 5 0 0 1 6.1 3.575l1.01 3.87-6.857 1.79a5 5 0 0 1-6.1-3.574 4 4 0 0 1 2.86-4.88l-.013.002Zm22.756 3.341-6.85 1.788-1.01-3.87a5 5 0 0 1 3.574-6.1l2.992-.782a4 4 0 0 1 4.881 2.86 5 5 0 0 1-3.587 6.104Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='m26.244 14.063-5.805 1.515 1.515 5.806 5.806-1.516-1.516-5.805Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M21.84 9.064a3 3 0 0 1 3.66 2.145l.736 2.816-5.806 1.515-.735-2.815a3 3 0 0 1 2.145-3.66Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconUnlockedRewards
